enum MedicalInfoType {
  Fecal = 'Fecal',
  Prevention = 'Prevention',
  SpayAndNeuter = 'SpayAndNeuter',
  Vaccination = 'Vaccination',
}

export default MedicalInfoType
